import { t } from "i18next";
import { shoppingListItemSchema, ValidationError } from "../models";
import { apiRequest } from "./apiService";
import { sanitizeArray, sanitizeObject, validateArray, validateObject } from "./validationService";

const shoppingListUrl = process.env.REACT_APP_DB_URL + "/shoppingLists";

/**
 * Fetch shopping lists for a user
 */
export const fetchShoppingLists = async (userId) => {
  if (!userId) return [];
  return await apiRequest(`${shoppingListUrl}/${userId}.json`);
};

/**
 * Update shopping lists for a user
 */
export const updateShoppingList = async (userId, shoppingLists) => {
  if (!userId) {
    throw new Error(t("errors.userNotAuthenticated"));
  }
console.log("shoppingLists", shoppingLists);
  const errors = validateArray(shoppingLists, shoppingListItemSchema);
  if (errors.length > 0) {
    const errorMessage = t("errors.invalidData", { count: errors.length });
    console.error("Validation errors:", errors);
    throw new ValidationError(errorMessage, errors);
  }

  // Sanitize data to ensure it matches the schema
  const sanitizedData = sanitizeArray(shoppingLists, shoppingListItemSchema);

  return await apiRequest(`${shoppingListUrl}/${userId}.json`, "PUT", sanitizedData);
};

/**
 * Add a single item to the shopping list
 */
export const addShoppingListItem = async (userId, item) => {
  if (!userId) {
    throw new Error(t("errors.userNotAuthenticated"));
  }

  const errors = validateObject(item, shoppingListItemSchema);
  if (Object.keys(errors).length > 0) {
    console.error("Validation errors:", errors);
    throw new ValidationError(t("errors.invalidShoppingItem"), errors);
  }

  // Sanitize data to ensure it matches the schema
  const sanitizedItem = sanitizeObject(item, shoppingListItemSchema);

  //TODO: This should not be needed - use PATCH instead
  const existingLists = (await fetchShoppingLists(userId)) || [];
  const updatedLists = [...existingLists, sanitizedItem];

  return await apiRequest(`${shoppingListUrl}/${userId}.json`, "PUT", updatedLists);
};
